module.exports = __webpack_public_path__ + "static/media/contact-bg-.caea2210.jpg";